import { BehaviorSubject } from "rxjs";

export const smallstackApiUrl: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
export const smallstackUrl: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
